import createAddressSummary from './createAddressSummary';

export default createAddressSummary;
